<ng-container *transloco="let t">
    <!-- Breadcrumb -->
    <div
        class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-between"
    >
        <h5 class="mb-0">
            {{ t("scan-detail") }}
        </h5>
        <ol class="breadcrumb list-unstyled mt-0 mb-0 pl-0">
            <li class="breadcrumb-item position-relative">
                {{ t("ASM") }}
            </li>
            <li class="breadcrumb-item position-relative">
                {{ t("scan-history") }}
            </li>
            <li class="breadcrumb-item position-relative">
                {{ t("scan-detail") }}
            </li>
        </ol>
    </div>
    @if (isLoadingResults || isRateLimitReached) {
    <div class="loading-shade">
        @if (isLoadingResults) {
        <mat-spinner></mat-spinner>
        } @if (isRateLimitReached) {
        <div class="rate-limit-reached">
            ALTAIR rate limit has been reached. It will be reset in one minute.
        </div>
        }
    </div>
    }
    <!-- Scan Detail -->
    <mat-card
        class="altair-card scan-detail-card mb-25 border-radius bg-white border-none d-block"
        [class.rtl-enabled]="themeService.isRTLEnabled()"
    >
        <mat-card-content>
            <mat-tab-group dynamicHeight>
                <mat-tab label="{{ t('home') }}">
                    <!-- Home -->
                    <app-home #home></app-home>
                </mat-tab>
                <mat-tab label="{{ t('subdomains') }}">
                    <!-- Subdomains -->
                    <app-subdomains #subdomains></app-subdomains>
                </mat-tab>
                <mat-tab label="{{ t('visualization') }}">
                    <!-- Visualization -->
                    <app-visualization #visualization></app-visualization>
                </mat-tab>
            </mat-tab-group>
        </mat-card-content>
    </mat-card>
</ng-container>
